import { useCallback, useMemo } from 'react';
import { useNavigate } from 'react-router';
import { routes } from 'routes/routes';
import { message } from 'ui';
import { useJoinProgramMutation } from '../../../../queries/mutations';

export const useJoinProgram = ({ programId }: { programId: string }) => {
  const navigate = useNavigate();
  const { isPending: isJoining, mutate } = useJoinProgramMutation();

  const joinProgram = useCallback(() => {
    mutate(
      { programId },
      {
        async onSuccess() {
          message.success('You have joined the program.');
          await navigate(routes.program.timeline(programId));
        },
      },
    );
  }, [mutate, navigate, programId]);

  return useMemo(() => ({ isJoining, joinProgram }), [isJoining, joinProgram]);
};
